import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled(Link)`
  cursor: pointer;
  background-color: var(--secondary-cobalt-blue);
  padding: 4px 4px 4px 14px;
  gap: 12px;
  display: flex;
  min-width: 180px;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid transparent;
  outline: none;
  align-items: center;
  transition: 300ms;
  text-decoration: none;
  &:hover {
    border: 1px solid #ffffff8b;
  }
  @media only screen and (max-width: 640px) {
    width: 100%;
  }
`;

const Text = styled.p`
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
`;

export const ButtonHeader = ({ text, icon, link }) => {
  return (
    <Container to={link}>
      <Text>{text}</Text>
      {icon}
    </Container>
  );
};
